import React, { useState } from "react";
import { Box, Button, IconButton, Icon } from "@mui/material";
import ShipmentCalendar from "./ShipmentCalendar";
import ShipmentCompleteTable from "./ShipmentCompleteTable";
import ShipmentCrudTable from "./ShipmentCrudTable";

const CALENDAR_PANEL_WIDTH = 380;

export default function ShipmentEmbarquesTab({ companyId }) {
  const [calendarOpen, setCalendarOpen] = useState(true);
  const [useCrudView, setUseCrudView] = useState(true);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        minHeight: "600px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 0,
          pr: calendarOpen ? 2 : 0,
          transition: calendarOpen
            ? "padding 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms"
            : "padding 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        }}
      >
        <Box mb={2}>
          <Button
            variant="outlined"
            onClick={() => setUseCrudView((prev) => !prev)}
          >
            {useCrudView ? "Vista original" : "Vista nueva"}
          </Button>
        </Box>
        {useCrudView ? (
          <ShipmentCrudTable companyId={companyId} />
        ) : (
          <ShipmentCompleteTable companyId={companyId} />
        )}
      </Box>
      <Box
        sx={{
          width: calendarOpen ? CALENDAR_PANEL_WIDTH : 0,
          flexShrink: 0,
          transition: calendarOpen
            ? "width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms"
            : "width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
          overflow: "hidden",
          ...(calendarOpen && {
            borderLeft: 1,
            borderColor: "divider",
          }),
        }}
      >
        <Box
          sx={{
            width: CALENDAR_PANEL_WIDTH,
            minHeight: "600px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderBottom: 1,
              borderColor: "divider",
              flexShrink: 0,
              pl: 2,
              pb: 1,
            }}
          >
            <IconButton
              onClick={() => setCalendarOpen(false)}
              aria-label="Ocultar calendario"
              size="large"
              edge="start"
            >
              <Icon>chevron_right</Icon>
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, minHeight: 0 }}>
            <ShipmentCalendar companyId={companyId} />
          </Box>
        </Box>
      </Box>
      <IconButton
        onClick={() => setCalendarOpen(true)}
        aria-label="Mostrar calendario"
        size="large"
        edge="end"
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          zIndex: 1,
          ...(calendarOpen && { display: "none" }),
        }}
      >
        <Icon>calendar_month</Icon>
      </IconButton>
    </Box>
  );
}
